var _g, _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3875_4414)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 23,
    rx: 3.33333,
    fill: "#ACC9F5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 40,
    height: 5.83333,
    fill: "#303636"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.8936,
    y: 13,
    width: 27.1061,
    height: 15,
    rx: 4,
    fill: "#E47E3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8676 23.1374L27.1336 21.1634L25.5656 22.3954L24.8936 21.2054L26.7276 20.4774L24.9076 19.7774L25.5376 18.6434L27.1476 19.8614L26.8676 17.8594H28.1696L27.8896 19.8614L29.4856 18.6434L30.1016 19.7634L28.2816 20.4914L30.1156 21.2194L29.4576 22.3814L27.8896 21.1634L28.1556 23.1374H26.8676Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8096 23.1374L34.0756 21.1634L32.5076 22.3954L31.8356 21.2054L33.6696 20.4774L31.8496 19.7774L32.4796 18.6434L34.0896 19.8614L33.8096 17.8594H35.1116L34.8316 19.8614L36.4276 18.6434L37.0436 19.7634L35.2236 20.4914L37.0576 21.2194L36.3996 22.3814L34.8316 21.1634L35.0976 23.1374H33.8096Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7516 23.1374L41.0176 21.1634L39.4496 22.3954L38.7776 21.2054L40.6116 20.4774L38.7916 19.7774L39.4216 18.6434L41.0316 19.8614L40.7516 17.8594H42.0536L41.7736 19.8614L43.3696 18.6434L43.9856 19.7634L42.1656 20.4914L43.9996 21.2194L43.3416 22.3814L41.7736 21.1634L42.0396 23.1374H40.7516Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3875_4414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 23,
    rx: 3.33333,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/cvc.687136af513c53a297937be9c7d0aadb.svg";
export { ForwardRef as ReactComponent };